var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default"),_c('span',{staticClass:"icon",attrs:{"test-id":"info_card-icon"}},[_vm._v("!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }